module.exports = __webpack_public_path__ + "static/img/imageCover.0ec6bd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/imageCover.png
// module id = 0ihp
// module chunks = 1